import { apiClient } from '@/core/api/client';
import { ENDPOINTS } from '@/core/api/endpoints';
import { PagoSchema } from '@/data/dto/pago';
import { PagosGlobalesSchema, } from '@/data/dto/pagoGlobal';
export const pagoGlobalApi = {
    async listar(filtros) {
        const res = await apiClient.get(ENDPOINTS.pagos, {
            params: {
                fechaDesde: filtros.fechaDesde || undefined,
                fechaHasta: filtros.fechaHasta || undefined,
                metodo: filtros.metodo || undefined,
                estado: filtros.estado || undefined,
                tipo: filtros.tipo || undefined,
                q: filtros.q || undefined,
                pagina: filtros.pagina,
                porPagina: filtros.porPagina,
            },
        });
        return PagosGlobalesSchema.parse(res.data);
    },
    async ver(id) {
        const res = await apiClient.get(`${ENDPOINTS.pagos}/${id}`);
        return PagoSchema.parse(res.data);
    },
};
